import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import LogoPurple from 'components/no-auth/header/LogoPurple';
import BasePage from 'components/utils/BasePage';
import Loading from 'components/utils/Loading';

import { toggleSpinner } from 'actions/appAction';
import { setExtra } from 'actions/extraAction';
import { updatePageMessages } from 'actions/messageAction';

import { EMAIL_UNSUBSCRIBE, EMAIL_UNSUBSCRIBE_CONFIRM } from 'constants/UrlConstants';

import { apiFetchData } from 'helpers/api';

import UnsubscribeSuccess from './UnsubscribeSuccess';
import { CommonPagePromo } from '../common/CommonPagePromo';
import { LightNavBar } from '../common/fromAuth/LightNavBar/LightNavBar';
import { PromoInfoPage } from '../common/PromoInfoPage/PromoInfoPage';

const Unsubscribe = (props) => {
    const [showSuccess, setShowSuccess] = useState(props.isShowSuccess);

    useEffect(() => {
        setShowSuccess(props.isShowSuccess);
    }, [props.isShowSuccess]);

    if (props.landing) {
        return <Loading />;
    }

    const unsubscribe = (e) => {
        e.preventDefault();
        props.toggleSpinner(true);
        apiFetchData(`${EMAIL_UNSUBSCRIBE_CONFIRM}${props.code}`)
            .then((json) => {
                if (json) {
                    if (json.messages) {
                        props.updatePageMessages(json.messages);
                    }
                    if (json.extra) {
                        props.setExtra(json.extra);
                    }
                }
                props.toggleSpinner(false);
            })
            .catch(() => props.toggleSpinner(false));
    };

    return (
        <CommonPagePromo>
            <LightNavBar align="left">
                <LogoPurple lang={props.lang} country={props.country} />
            </LightNavBar>
            {!showSuccess && (
                <PromoInfoPage
                    iconName="envelope-cross-thin"
                    iconColor="purple"
                    headerText={props.emailUnsubscribeTitle}
                    secondaryText={props.emailUnsubscribeText}
                    primaryButtonCaption={props.emailUnsubscribeButton}
                    primaryButtonType="link"
                    primaryButtonLink={`${EMAIL_UNSUBSCRIBE_CONFIRM}${props.code}`}
                    primaryButtonOnClick={unsubscribe}
                />
            )}
            {showSuccess && <UnsubscribeSuccess />}
        </CommonPagePromo>
    );
};
const mapStateToProps = (state) => {
    return {
        emailUnsubscribeTitle: state.messages.pageMessages.emailUnsubscribeTitle,
        emailUnsubscribeText: state.messages.pageMessages.emailUnsubscribeText,
        emailUnsubscribeButton: state.messages.pageMessages.emailUnsubscribeButton,
        code: state.extra.code,
        isShowSuccess: state.extra.isShowSuccess,
        lang: state.language.lang,
        country: state.app.country,
    };
};

export default connect(mapStateToProps, {
    updatePageMessages,
    setExtra,
    toggleSpinner,
})(BasePage(Unsubscribe, EMAIL_UNSUBSCRIBE));
